import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'black-accordion-header-default',
    templateUrl: './accordion-header-default.component.html',
    styleUrls: ['./accordion-header-default.component.css'],
    standalone: false
})
export class AccordionHeaderDefaultComponent {

  @Input()
  index = ''

  @Input()
  title = ''

  @Input()
  expanded = false

  @Output()
  toggleEvent : EventEmitter<any> = new EventEmitter()

  @Output()
  deleteEvent : EventEmitter<any> = new EventEmitter()

  dispatchToggleEvent(){
    this.toggleEvent.emit()
  }

  dispatchDeleteEvent(){
    this.deleteEvent.emit()
  }

}
